import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {IFieldActivity} from '../../shared/model/field-activity.model';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';

type EntityResponseType = HttpResponse<IFieldActivity>;
type EntityArrayResponseType = HttpResponse<IFieldActivity[]>;

@Injectable({ providedIn: 'root' })
export class FieldActivityService {
    public resourceUrl = SERVER_API_URL + 'api/field-activities';

    constructor(protected http: HttpClient) {}

    create(fieldActivity: IFieldActivity): Observable<EntityResponseType> {
        return this.http.post<IFieldActivity>(this.resourceUrl, fieldActivity, { observe: 'response' });
    }

    update(fieldActivity: IFieldActivity): Observable<EntityResponseType> {
        return this.http.put<IFieldActivity>(this.resourceUrl, fieldActivity, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<IFieldActivity>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IFieldActivity[]>(this.resourceUrl, { params: options, observe: 'response' });
    }
    query2(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IFieldActivity[]>(SERVER_API_URL + 'api/temp-customer-project', { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }
}
